import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import StatusChanger from "../status-chenger";
import { Link } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";
import { Button } from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Data from "../../../common/custom-modal/Data";

const DataTable = ({
  data,
  setData,
  rowsPerPage,
  currentPage,
  status,
  pinPlace,
}) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  // Sorting logic
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Sorting function for table rows
  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  // Export to PDF functionality
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text(" Pins Data Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        [
          "ID",
          "Order ID",
          "Title",
          "URL",
          "Description",
          "Pin Place",
          "Days Subscription",
          "Active Start Date",
          "Days Active",
          "Status",
        ],
      ],
      body: sortedData.map((item) => [
        item?.id,
        item?.request_id,
        item?.pin_title,
        item?.pin_url,
        item?.pin_text,
        item?.pin_place,
        item?.count_days_subscriptions,
        item?.date_start_active,
        item?.count_days_active,
        item?.status,
      ]),
    });
    doc.save("pin-data_table.pdf");
  };

  return (
    <>
      {/*<Button*/}
      {/*  variant="contained"*/}
      {/*  color="primary"*/}
      {/*  onClick={exportPDF}*/}
      {/*  style={{ marginBottom: 16 }}*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</Button>*/}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="sortable and exportable table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "ID", field: "id" },
                { label: "Order ID", field: "request_id" },
                { label: "Title", field: "pin_title" },
                { label: "URL", field: "pin_url" },
                { label: "Description", field: "pin_text" },
                { label: "Pin Place", field: "pin_place" },
                { label: "Days Subscription", field: "count_days_subscriptions" },
                { label: "Active Start Date", field: "date_start_active" },
                { label: "Days Active", field: "count_days_active" },
                { label: "Status", field: "status" },
              ].map(({ label, field }) => (
                <TableCell
                  key={field}
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                >
                  <TableSortLabel
                    active={orderBy === field}
                    direction={orderBy === field ? order : "asc"}
                    onClick={() => handleSort(field)}
                  >
                    {label}
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {item?.id}
                </TableCell>
                <TableCell align="center">{item?.request_id}</TableCell>
                <TableCell align="center">{item?.pin_title}</TableCell>
                <TableCell align="center">
                  <a
                    href={item?.pin_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item?.pin_url}
                  </a>
                </TableCell>
                <TableCell align="center">
                  <Data data={item?.pin_text} />
                </TableCell>
                <TableCell align="center">{item?.pin_place}</TableCell>
                <TableCell align="center">
                  {item?.count_days_subscriptions}
                </TableCell>
                <TableCell align="center">{item?.date_start_active}</TableCell>
                <TableCell align="center">
                  {" "}
                  <div className={`w-full flex items-center justify-center`}>
                    {(() => {
                      const percentage =
                        (item?.count_days_active /
                          item?.count_days_subscriptions) *
                        100;
                      let bgColor;
                      if (percentage >= 80) {
                        bgColor = "bg-red-600";
                      } else if (percentage >= 65) {
                        bgColor = "bg-red-500";
                      } else if (percentage >= 50) {
                        bgColor = "bg-red-400";
                      } else {
                        bgColor = undefined;
                      }

                      return (
                        <span
                          className={`w-fit p-2 font-bold rounded-md ${bgColor
                            ? `${bgColor} text-darkTextColor`
                            : "bg-transparent"
                            }`}
                        >
                          {item?.count_days_active}
                        </span>
                      );
                    })()}
                  </div>
                </TableCell>
                <TableCell align="center">
                  <StatusChanger
                    data={item}
                    setData={setData}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    status={status}
                    pinPlace={pinPlace}
                  />
                </TableCell>
                <TableCell align="center">
                  <div className="flex gap-x-10 text-lg items-center justify-center">
                    <Link
                      to={`/Ads-Pin/Edit/${item?.id}`}
                      color="inherit"
                      underline="none"
                    >
                      <FaPencilAlt className="text-[#6c757d]" />
                    </Link>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
